// extracted by mini-css-extract-plugin
export var standaloneTable = "_m-0";
export var standaloneTableWithBodyFill = "_m-1";
export var withExtraHeader = "_m-2";